<template>
  <div class="my-4">
    <a href="https://github.com/jankowski-app" target="_blank">
      <v-icon large>mdi-github</v-icon>
    </a>
  </div>
</template>

<script>
export default {
  name: 'SocialContacts',
}
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
